export { default } from './get-email-origin-id';
